import { RISK_LEVEL } from '@/constants/riskLevels';

export const getCustomerRiskLevelProperties = (riskLevel) => {
  let properties = {};

  switch (riskLevel) {
    case RISK_LEVEL.HIGH:
      properties = {
        label: 'High Risk',
        icon: 'small-alert-triangle',
        iconColor: 'light-error-90',
        iconBackgroundColor: 'light-error-30',
      };
      break;
    case RISK_LEVEL.MEDIUM:
      properties = {
        label: 'Medium Risk',
        icon: 'small-alert-triangle',
        iconColor: 'light-warning-90',
        iconBackgroundColor: 'light-warning-30',
      };
      break;
    case RISK_LEVEL.LOW:
      properties = {
        label: 'Low Risk',
        icon: 'small-check-circle',
        iconColor: 'light-success-90',
        iconBackgroundColor: 'light-success-30',
      };
      break;
    case RISK_LEVEL.NOT_APPLICABLE:
      properties = {
        label: 'Not Applicable',
        icon: 'small-info-circle',
        iconColor: 'light-neutral-90',
        iconBackgroundColor: 'light-neutral-30',
      };
      break;
    default:
      break;
  }

  return properties;
};
